import style from "./Product.module.scss"
import React, { useEffect, useState } from 'react';
import { SquarePen, Trash, Plus, Search, MoveUp, MoveDown } from 'lucide-react';
import Button from "react-bootstrap/Button";
import EditProductModal from "../commonComponents/ItemModals/EditItemModal.jsx";
import ViewProductModal from "../commonComponents/ItemModals/ViewItemModal.jsx";
import DeleteModal from "../commonComponents/ItemModals/DeleteItemModal.jsx";
import AddItemModal from "../commonComponents/ItemModals/AddItemModal.jsx";
import fetchProducts from "../../services/products/fetchProducts.js";
import { InputGroup, FormControl } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import DeleteProduct from "../../services/products/deleteProducts.js";
import { toast } from "react-toastify";
import ITEM_TOASTS from "../../utils/constants/toastMesages/itemToastMessage.js";
import Card from 'react-bootstrap/Card';
import { APP_CONFIG } from '../../utils/runtimeConfig.js';

/**
 * @description
 * A component that renders basically on Adminpanel section and it consists a table containing product lists that can be 
 * manipulated by user's preference.
 * 
 * @returns {JSX.Element} - renders a table with items that can be sorted acoording to users preference
 */

function Product() {
  //Stste to control fetched products data and save them
  const [items, setItems] = useState([]);
  //State to save filtered items according to user preferences
  const [filteredItems, setFilteredItems] = useState([]);
  //State to save and search term in searchbar
  const [searchTerm, setSearchTerm] = useState('');
  //UseState that handles selected category state
  const [categoryFilter, setCategoryFilter] = useState('All');
  //UseState hook that handles user selected product type state
  const [typeFilter, setTypeFilter] = useState('All');
  //UseState hook for controling minimum price entered by user
  const [minPrice, setMinPrice] = useState('');
  //UseState hook for controling maximum price entered by user
  const [maxPrice, setMaxPrice] = useState('');
  //Handles page numbers state for pagination
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  //States to handle showing modal for editing an item
  const [editItemModal, setEditItemModal] = useState(false)
  //State to track current editing item
  const [editingItem, setEditingItem] = useState([])
  //State track current viewing item
  const [viewItemModal, setViewItemModal] = useState(false);
  //State to handle showing of delete modal
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  //State to handle adding items modal
  const [addItemModal, setAddItemModal] = useState(false);
  //State for sorting items ascending and descending order
  const [ascending, setAscending] = useState(false)
  // States for tracking if delete button is clicked or not
  const [refetchFlag, setRefetchFlag] = useState(false);

  //Getting low stck quantity thresh hold from env
  const quantityThreshhold = APP_CONFIG.lowStockThreshold;


  //States for hadnling edit items states
  const [itemDetails, setItemDetails] = useState({
    id: "",
    prodName: "",
    prodPrice: null,
    prodCategoryId: "",
    quantity: "",
    description: "",
    imageUrl: "",
    veg: true
  })

  //Handler function to handle current editing item
  const editingHandler = (item) => {
    setEditingItem(item);
    setEditItemModal(true)
    setItemDetails({
      id: item._id,
      prodName: item.name,
      prodPrice: item.price,
      prodCategoryId: item.category_id || item.categoryId,
      prodCategoryName: item.category?.name || item.category,
      quantity: item.stockQuantity,
      description: item.description || "",
      imageUrl: item.imageUrl || "",
      veg: item.veg !== undefined ? item.veg : true
    })
  }

  //Handler function to show vie product modal
  const viewHandler = (item) => {
    setEditingItem(item);
    setViewItemModal(true)

  }

  //Handler function to show delete modal
  const deleteHandler = (item) => {
    setEditingItem(item);
    setDeleteItemModal(true)
  }

  //Add item Modal andler
  const addHandler = () => {
    setAddItemModal(true)
  }

  //States to track filter property states 
  const [checked, setChecked] = useState({
    category: false,
    type: false,
    price: false
  });

  //UseEffect hook for sorting items 
  useEffect(() => {
    ///This fetch method fetches data from the backend and saves the data in the frontend ui.
    const fetchData = async () => {
      try {
        const data = await fetchProducts();
        setItems(data.data)
        setFilteredItems(data.data)
      } catch (error) {
        console.error(ITEM_TOASTS.ITEMS_NOT_FETCHED);
      }
    };

    fetchData();
    // Despendencies, when ever item updats happen
  }, [editItemModal, deleteItemModal, addItemModal, refetchFlag]);

  //UseEffect hook for methds related to filtering 
  // Products by preferences (ex: categories, price, search term, item type etc..)
  useEffect(() => {
    let filtered = [...items]; // Create a copy of the original array to avoid mutating state directly

    if (categoryFilter !== 'All') {
      filtered = filtered.filter(item =>
        (item.category?.name || item.category)?.toLowerCase() === categoryFilter.toLowerCase()
      );
    }

    if (typeFilter !== 'All') {
      filtered = filtered.filter(item =>
        (item.veg ? 'Veg' : 'Non Veg').toLowerCase() === typeFilter.toLowerCase()
      );
    }

    if (checked.price) {
      filtered = filtered.filter(item => {
        const price = Number(item.price);
        const min = minPrice ? Number(minPrice) : -Infinity;
        const max = maxPrice ? Number(maxPrice) : Infinity;
        return price >= min && price <= max;
      });
    }

    if (searchTerm) {
      const lowerSearch = searchTerm.trim().toLowerCase();
      filtered = filtered.filter(item =>
        item.name?.toLowerCase().includes(lowerSearch) ||
        item.description?.toLowerCase().includes(lowerSearch)
      );
    }

    // Apply sorting
    filtered.sort((a, b) => {
      const priceA = Number(a.price);
      const priceB = Number(b.price);
      return ascending ? priceA - priceB : priceB - priceA;
    });

    setFilteredItems(filtered);
    setPageNumber(1);
  }, [items, searchTerm, categoryFilter, typeFilter, minPrice, maxPrice, checked.price, ascending]); // Added ascending to dependencies

  //Pagination logic 
  const totalPages = Math.ceil(filteredItems.length / pageSize);
  const startIndex = (pageNumber - 1) * pageSize;
  const currentItems = filteredItems.slice(startIndex, startIndex + pageSize);

  //States for saving and selecting all the cashier select box
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  //Function for selecting all checbox by th select box
  const selectAllCheckBox = () => {
    const allIds = currentItems.map(person => person._id);
    if (selectAll) {
      setSelectedIds([]);
    }
    else {
      setSelectedIds(allIds);
    }
    setSelectAll(!selectAll);
  }

  //Function for handling single checkbox selection
  const handleSingleSelect = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(prev => prev.filter(_id => _id !== id));
    }
    else {
      setSelectedIds(prev => [...prev, id])
    }
  }

  // Api handler for deleting an item 
  const deleteItem = async (item) => {
    try {
      const res = await DeleteProduct(item._id);
      if (!res.success) {
        throw new Error(ITEM_TOASTS.ITEMS_NOT_FETCHED);
      }
    } catch (error) {
      toast.error(ITEM_TOASTS.ITEMS_NOT_FETCHED);
      throw error; // Rethrow so `Promise.all` can catch it
    }
  };

  //Delete selected products 
  const deleteMultipleProducts = async () => {
    try {
      // Create an array of promises for all deletions
      const deletionPromises = selectedIds.map(id => {
        // Find the full item object from the items array
        const itemToDelete = items.find(item => item._id === id);
        if (!itemToDelete) {
          throw new Error(`Item with ID ${id} not found`);
        }
        return deleteItem(itemToDelete);
      });

      await Promise.all(deletionPromises);

      setSelectedIds([]);
      setSelectAll(false);
      toast.success(ITEM_TOASTS.ITEMS_DELETED);

      setDeleteItemModal(false);
      setRefetchFlag(prev => !prev);
    } catch (error) {
      toast.error(ITEM_TOASTS.ITEMS_NOT_DELETED);
    }
  }

  //Handle checkbox unchecking sorting parameters
  const handleUncheckBox = (filterName) => {
    setChecked((prev) => ({
      ...prev,
      [filterName]: false,
    }));

    // Reset filter values if needed
    if (filterName === "category") setCategoryFilter("All");
    if (filterName === "type") setTypeFilter("All");
    if (filterName === "price") {
      setMinPrice("");
      setMaxPrice("");
    }
  };

  return (
    <>
      <div className={`${style.containerDiv} container-fluid p-4`}>
        {/* Header Section */}
        <div className={`${style.productsHeader} d-flex justify-content-between align-items-center mb-4`}>
          <div>
            <h4 className="mb-0">Products Management</h4>
            <p className="text-muted mb-0">
              Manage restaurant products and inventory
            </p>
          </div>
        </div>

        {/* Search Bar */}
        <div className={`${style.SearchButton} d-flex flex-column flex-md-row mb-4 gap-2 justify-content-between`}>
          <InputGroup className={`${style.searchBox} `} >
            <InputGroup.Text><Search size={16} /></InputGroup.Text>
            <FormControl
              placeholder="Search items..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
          <div className={`${style.addButton} d-flex gap-2`}>
            <Button
              variant="primary"
              onClick={() => addHandler()}
              className="d-flex align-items-center justify-content-center gap-2 w-100"
            >
              <Plus size={15} />
              Add Item
            </Button>
            {selectedIds.length > 0 && <div className={`pt-1 ${style.selectedTrash}`} onClick={() => { deleteMultipleProducts() }}><Trash /></div>}
          </div>
        </div>
        <span className="d-flex gap-3 pb-2" style={{ overflowX: "auto" }}>
          {checked.category &&
            <div className="d-flex align-items-center gap-2">
              <select
                className={`form-select ${style.sortParameterSize}`}
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
                style={{ maxWidth: "200px", minWidth: "150px" }}
              >
                <option value="All">All Categories</option>
                {Array.from(new Set(items.map(item => item.category?.name || item.category))).map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select><div className={`${style.crossDesign} btn btn-sm btn-outline-secondary`} onClick={() => handleUncheckBox("category")}>✕</div> </div>
          }
          {/* If product type is selected, product type select will be rendered */}
          {checked.type &&
            <div className="d-flex align-items-center gap-2">
              <select
                className={`form-select ${style.sortParameterSize}`}
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}

              >
                <option value="All">All Types</option>
                <option value="Veg">Veg</option>
                <option value="Non Veg">Non Veg</option>
              </select>
              <div className={`${style.crossDesign} btn btn-sm btn-outline-secondary`} onClick={() => handleUncheckBox("type")}>✕</div>
            </div>
          }
          {/* If product price is selected, select price in range option will be rendered */}
          {checked.price &&
            <div className="d-flex align-items-center gap-2">
              <div className={`d-flex gap-1 align-items-center ${style.sortParameterSize}`}>
                <input
                  className={`${style.sortDivWidth} form-control`}
                  style={{ width: "70px" }}
                  type="number"
                  placeholder="Min"
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                />
                <span>-</span>
                <input
                  className="form-control"
                  style={{ width: "70px" }}
                  type="number"
                  placeholder="Max"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                />
              </div>
              <div className={`${style.crossDesign} btn btn-sm btn-outline-secondary`} onClick={() => handleUncheckBox("price")}>✕</div>
            </div>
          }
        </span>

        {/* Main table section */}
        <Card className={style.categoriesCard}>
          <Card.Body>
            <div className="table-responsive">
              <table className={`table ${style.categoriesTable}`}>
                <thead>
                  <tr>
                    <th>
                      <Form.Check // prettier-ignore
                        type="checkbox"
                        onClick={() => selectAllCheckBox()}
                        id={`default-checkbox`} />
                    </th>
                    <th className="text-center">SL/NO</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Category</th>
                    <th className="text-center">Description</th>
                    <th className={`${style.hidden} text-center`}>Type</th>
                    <th className={`${style.hidden} text-center`}>Stock Quantity</th>
                    <th className="text-center" style={{ cursor: "pointer" }} onClick={() => ascending ? setAscending(false) : setAscending(true)}>Price{ascending ? <MoveUp size={15} /> : !ascending ? <MoveDown size={15} /> : <MoveUp />}</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((row, index) => (
                    <tr key={index} style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); viewHandler(row) }}>
                      <td>
                        <Form.Check // prettier-ignore
                          type="checkbox"
                          checked={selectedIds.includes(row._id)}
                          onChange={() => handleSingleSelect(row._id)}
                          onClick={(e) => e.stopPropagation()}
                          id={`default-checkbox`} />
                      </td>
                      <td className='text-center fw-bold'>{index + 1}</td>
                      <td className="text-center">{row.name}</td>
                      <td className="text-center text-muted">{row.category?.name || row.category}</td>
                      <td className="text-center">{row.description || '-'}</td>
                      <td className={`${style.hidden} text-center text-muted`}>{row.veg ? "Veg" : "Non Veg"}</td>
                      <td className={`${style.hidden} text-center`} style={{ color: row.stockQuantity <= quantityThreshhold ? "red" : "", fontWeight: row.stockQuantity <= quantityThreshhold ? "bold" : "" }}>{row.stockQuantity}</td>
                      <td className="text-center">{row.price}</td>
                      <td className="text-center justify-content-center gap-2 d-flex">
                        <div
                          className="bg-warning cursor-pointer d-flex align-items-center justify-content-center"
                          style={{ width: '32px', height: '32px', borderRadius: '4px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            editingHandler(row);
                          }}
                          title="Edit Product"
                        >
                          <SquarePen size={16} color="white" />
                        </div>

                        <div
                          className="bg-danger cursor-pointer d-flex align-items-center justify-content-center"
                          style={{ width: '32px', height: '32px', borderRadius: '4px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteHandler(row);
                          }}
                          title="Delete Product"
                        >
                          <Trash size={16} color="white" />
                        </div>
                      </td>
                    </tr>
                  ))}
                  {currentItems.length === 0 && (
                    <tr>
                      <td className="text-center" colSpan="9">No products found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>

        {/* Edit item modal */}
        <EditProductModal item={editingItem} itemDetails={itemDetails} setItemDetails={setItemDetails} className={`${style.custModal}`} show={editItemModal} onHide={() => setEditItemModal(false)} />

        {/* View product modal */}
        <ViewProductModal item={editingItem} className={`${style.custModal}`} show={viewItemModal} onHide={() => setViewItemModal(false)} />

        {/* Delete Item Modal */}
        <DeleteModal item={editingItem} className={`${style.custModal}`} show={deleteItemModal} onHide={() => setDeleteItemModal(false)} />

        {/* Add items modal */}
        <AddItemModal className={`${style.custModal}`} show={addItemModal} onHide={() => setAddItemModal(false)} />

        {/* Pagination handler buttons */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={pageNumber === 1}
              onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
            >
              &laquo;
            </Button>

            <span>
              Page <strong>{pageNumber}</strong> of {totalPages}
            </span>

            <Button
              variant="outline-secondary"
              size="sm"
              disabled={pageNumber === totalPages}
              onClick={() => setPageNumber(prev => Math.min(prev + 1, totalPages))}
            >
              &raquo;
            </Button>
          </div>
        )}

      </div>
    </>
  );
}

export default Product;
